// Windows 8 mobile Responsive utility
if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
	var msViewportStyle = document.createElement("style");
	msViewportStyle.appendChild(document.createTextNode("@-ms-viewport{width:auto!important}"));
	document.querySelector("head").appendChild(msViewportStyle);
}

// Jquery functions
$(document).ready(function () {
	// LazyLoading
	var myLazyLoad = new LazyLoad({
		elements_selector: "[data-src], [data-bg]",
		threshold: 400,
		callback_set: function (el) {
			objectFitImages(el);
		}
	});

	//Show images after ajax
	$(document).ajaxComplete(function () {
		myLazyLoad.update();
	});

	// Popojetí na kotvu z hlášky u Notices projektu
	$("[data-kt-target]").click(function () {
		var targetElement = $($(this).data("kt-target"));
		var targetBottomOffset = $(this).data("kt-bottom-offset");
		var targetTopOffset = $(this).data("kt-top-offset");
		moveToHtmlTarget(targetElement, targetTopOffset, targetBottomOffset);
	});

	// Odeslání formu přes JS
	$("#submitButton, .submitButton").click(function () {
		if ($(this).hasClass("disabled")) {
			return false;
		}
		$(this)
			.parents("form")
			.submit();
	});

	// Dodá všem iframe elmentům responsivní vlastnost v rámci entryContent (wysiwyg editor)
	$(".entry-content iframe").each(function () {
		if (
			$(this)
			.attr("src")
			.indexOf("youtube") != -1 ||
			$(this)
			.attr("src")
			.indexOf("vimeo") != -1
		) {
			$(this)
				.addClass("embed-responsive-item")
				.wrap('<div class="embed-responsive embed-responsive-16by9"></div>');
			$(this).removeAttr("width");
			$(this).removeAttr("height");
		}
	});

	// Dodá všem table elmentům responsivní vlastnost v rámci entryContent (wysiwyg editor)
	$(".entry-content table").each(function () {
		$(this)
			.addClass("table")
			.wrap('<div class="table-responsive"></div>');
	});

	//Fancybox inicializace
	galleryFancybox();

	//Fancybox
	$("[data-fancybox]").fancybox({
		buttons: ["close"],
		animationEffect: "fade",
		idleTime: 99
	});

	//Fancybox
	$("[data-fancybox] , .kt-img-link").fancybox({
		animationEffect: "fade",
		buttons: [
			"close"
			//"zoom",
			//"share",
			//"slideShow",
			//"fullScreen",
			//"download",
			//"thumbs",
		],
		idleTime: 99
	});

	//Prevent Default
	$(".js-prevent-default").click(function (e) {
		e.preventDefault();
	});
});

//WP gallery fancybox
function galleryFancybox() {
	var galleryID = "I";

	$(".gallery").each(function () {
		$(this)
			.find(".gallery-icon a")
			.attr("data-fancybox", galleryID);
		galleryID += "I";
	});
}

// Funkce pro animované posunutí na prvek v DOM dokumentu
function moveToHtmlTarget(elemnt, topOffset, bottomOffset) {
	var offset = elemnt.offset().top;

	if (topOffset > 0) {
		offset = offset - topOffset;
	}

	if (bottomOffset > 0) {
		offset = offset + bottomOffset;
	}

	$("html, body").animate({
			scrollTop: offset
		},
		1000
	);

	return this;
}